module.exports = __webpack_public_path__ + "img/bonus_symbol_4.5175a423.png";